// extracted by mini-css-extract-plugin
export default {"searchWrapper":"styles_searchWrapper__CMaPW","form":"styles_form__mvLmv","input":"styles_input__Ohd10","rootBtn":"styles_rootBtn__tfja9","btnsWrapper":"styles_btnsWrapper__a6tqQ"};